import { ChangeDetectorRef, Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { TextboxConfig } from '../../../design-system/textbox/textbox.modal';
import { TextboxComponent } from '../../../design-system/textbox/textbox.component';
import { TwoDigitDecimalNumberDirective } from '../../../../_directives/twoDigitDecimalNumber.directive';
import { IntizerOnlyDirective } from '../../../../_directives/intizerOnly.directive';
import { SixDigitAfterAndBeforeDecimalNumberDirective } from '../../../../_directives/sixDigitBeforeAndAfterDecimalNumber';
import { SharedModule } from '../../../../shared.module';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';

@Component({
  selector: 'formly-input',
  templateUrl: "./formly-input.component.html",
  standalone: true,
  imports: [TextboxComponent, ReactiveFormsModule, FormlyModule, TwoDigitDecimalNumberDirective, IntizerOnlyDirective, SixDigitAfterAndBeforeDecimalNumberDirective, SharedModule]
})
export class FormlyInputComponent extends FieldType implements OnInit, OnDestroy, DoCheck {

  constructor(private cdRef: ChangeDetectorRef, private dynamicFormService: DynamicFormService) { super(); }

  isFormSubmitted: boolean = false;
  private formSubmissionSubscription: Subscription;
  private originalHelperText: string | null = null;

  private valueChangeSub: any;
  fieldKey: string = '';
  textboxConfig: TextboxConfig = {
    id: '',
    label: '',
    placeholder: '',
    currencyText: null,
    disabled: true,
    required: false,
    size: 'md',
    rightSideText: null,
    helperText: null,
  };

  ngOnInit() {
    if (this.field.key)
      this.fieldKey = this.field.id ?? this.field.key.toString();
    this.textboxConfig.id = this.fieldKey;

    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
      this.syncErrorState();
      this.cdRef.detectChanges();
    });

    if (this.field.templateOptions) {
      this.textboxConfig.label = this.field.templateOptions.label;
      this.textboxConfig.disabled = this.field.templateOptions.disabled;
      this.textboxConfig.required = this.field.templateOptions.required;
      this.textboxConfig.size = this.field.templateOptions.size;
      this.textboxConfig.readonly = this.field.templateOptions.readonly;
      this.textboxConfig.maxLength = this.field.templateOptions.maxLength;
      this.textboxConfig.maxLengthCount = this.field.templateOptions.maxLengthCount;
      this.textboxConfig.rightSideText = this.field.templateOptions.rightSideText;
      this.textboxConfig.rightSideTextClass = this.field.templateOptions.rightSideTextClass;
      this.textboxConfig.currencyText = this.field.templateOptions.currencyText;
      this.textboxConfig.helperText = this.field.templateOptions.helperText;
      this.originalHelperText = this.field.templateOptions.helperText ?? null;
      this.textboxConfig.placeholder = this.field.templateOptions.placeholder;
      this.textboxConfig.iconSrc = this.field.templateOptions.iconSrc;
      this.textboxConfig.iconPosition = this.field.templateOptions.iconPosition;

    }

    if (this.field.templateOptions?.turnToCaps) {
      this.formControl.valueChanges.subscribe(value => {
        if (value && value !== value.toUpperCase()) {
          this.formControl.setValue(value.toUpperCase(), { emitEvent: false });
        }
      });
      }

      if (this.field && this.field.templateOptions && typeof this.field.templateOptions.change === 'function') {
          this.valueChangeSub = this.formControl.valueChanges.subscribe(value => {
              (this.field.templateOptions.change as Function)(this.field, value);
          });
      }
  }

    
  OnValueChange(val: string) {
    this.to.change(this.field, val);
  }

  ngDoCheck() {
    this.syncErrorState();
    if (this.field && this.field.templateOptions && this.textboxConfig.helperText !== this.field.templateOptions.helperText) {
        this.textboxConfig = {
            ...this.textboxConfig,
            helperText: this.field.templateOptions.helperText,
            isInvalid: this.field.templateOptions.isInvalid,
            value: this.formControl.value ?? ''
        };
    }
  }

  private syncErrorState(): void {
    const errorText = this.field.templateOptions?.errorText;
    let newIsInvalid = false;
    let newHelperText = this.originalHelperText;

    if (errorText) {
      newIsInvalid = true;
      newHelperText = errorText;
    } else if (this.isFormSubmitted && this.formControl.invalid) {
      newIsInvalid = true;
      if (this.formControl.errors?.required) {
        newHelperText = "Required";
      } else if (this.formControl.errors?.whitespace) {
        newHelperText = "Required";
      }
    }

    if (this.textboxConfig.isInvalid !== newIsInvalid || this.textboxConfig.helperText !== newHelperText) {
      this.textboxConfig = {
        ...this.textboxConfig,
        isInvalid: newIsInvalid,
        helperText: newHelperText,
        value: this.formControl.value ?? ''
      };
    }
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
     }
    if (this.valueChangeSub && typeof this.valueChangeSub.unsubscribe === 'function')
        this.valueChangeSub.unsubscribe();
   }

  intizerOnly(event: any) {
    if (this.field.props.intizerOnly) {
      const regex = /^[0-9]$/;
      let str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (regex.test(str)) {
        this.textboxConfig = {...this.textboxConfig, helperText: ''};
        return true;
      } else {
        this.textboxConfig = {...this.textboxConfig, helperText: 'Enter numbers only'};
        return false;
      }
    }
  }
}